<template>
    <div class="wrap white-bg">
        <div class="box1200">
            <div class="index-title">
                <h3 class="title">{{this.$store.state.siteName}}</h3>
                <p class="sort-title">个人流量变现神器 企业同城推广好帮手</p>
            </div>
            <!--index-title-->
            <div class="index-about">
                <p class="pic"><img src="@/assets/images/big-logo.png"></p>
                <p class="text">{{this.$store.state.siteName}}是一个基于本地微信生态、熟人社交关系的共享个人流量的同城营销推广服务平台。聚合本地企业商家和个人流量资源，一则为企业用户提供高供性价比、高转化率、高精准覆盖的同城即时推广服务，帮助企业快速找到、找对、用对达人推广资源;二则为达人用户提供即时对接同城企业商家的推广任务订单，随时随地轻松接单转发赚钱，实现个人流量变现。并且{{this.$store.state.siteName}}采用SAAS模式，提供标准化、可复制化的技术平台产品和运营管理模式给加盟商，让加盟商轻松创业、快速盈利，帮助自媒体及文化传媒公司快速优化升级业务结构，增加营收。</p>
            </div>
        </div>
        <!--index-about-->
        <router-link to="/about" class="index-btn">详细介绍</router-link>
    </div>
</template>
<script>
export default {
  name: 'HomeAbout'
}
</script>
<style>
    .index-about .pic{width:100%;text-align:center;padding:20px 0;}
    .index-about .text{padding:30px 0 0 0;font-size:14px;color:#333;line-height:36px;}
</style>
